var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"light","content":_vm.label,"placement":"bottom","open-delay":200,"disabled":_vm.label == ''}},[_c('el-checkbox',{attrs:{"label":_vm.value,"value":_vm.value}},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }